<!--
  - 代码运行状态栏
-->

<template>
  <div class="widget_statusbar" :style="{height: height}">
    <span>row: {{editor_status.row}} | col: {{editor_status.col}}</span>
    <span>[ {{editor_status.title | substr(0,10)}} ] - {{editor_status.author}}</span>
    <span>Language: {{editor_status.language}}</span>
    <span>count: {{editor_status.count}}</span>
  </div>
</template>


<script>
  // import '@/assets/css/icon/build.css'
  import {mapGetters} from 'vuex'

  export default {
    name: 'widget_statusbar',
    data(){
      return {}
    },
    props: {
      height: {
        type: String,
        default: '30px',
      },
    },
    components: {},
    computed: {
      ...mapGetters([
        'editor_status',
        'user',
      ]),
    },
    created(){
    }
  }
</script>

<style scoped lang="less">
  @statusbar_background: #252526;
  .widget_statusbar {
    z-index: 9;
    position: absolute;
    bottom: 0;
    width: 100%;
    background: @statusbar_background;
    color: white;
    padding: 0 15px;
    display: flex;
    align-items: center;
    font-size: 13px;

    span {
      padding-right: 20px;
    }
  }
</style>

